import { JiraLogo } from '@atlaskit/logo';
import { ConfluenceBannerFirstPartyRecommendation } from '@post-office/components--confluence-banner-first-party-recommendation';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import { createRender } from './types';

export const render = createRender(({ onDismissed }) => {
	const intl = useIntl();
	return (
		<ConfluenceBannerFirstPartyRecommendation
			app={{
				hamsIdentifier: 'jira-software.ondemand',
				ccpProductId: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
				logo: (
					<JiraLogo
						size="small"
						appearance="brand"
						label={intl.formatMessage({
							id: 'post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text',
							description:
								'Alt text for the product logo in Jira recommendation message in Confluence Home Banner',
							defaultMessage: 'Jira Product Logo',
						})}
					/>
				),
				header: (
					<FormattedMessage
						id="post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header"
						description="Header for Jira recommendation message in Confluence Home Banner"
						defaultMessage="Sync real-time data from Jira to any document in Confluence"
					/>
				),
				description: (
					<FormattedMessage
						id="post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description"
						description="Description for Jira recommendation message in Confluence Home Banner"
						defaultMessage="See analytics and insights about what your team is working on at any moment"
					/>
				),
			}}
			backgroundImage="swirls"
			onDismissed={onDismissed}
		/>
	);
});

export default render;
